import React, { memo } from 'react';
import { KeyboardArrowUp, KeyboardArrowDown, Search, Add } from '@mui/icons-material';
import { Box, Button, OutlinedInput } from '@mui/material';
import { Redirect } from 'react-router';
import NivelUsuarioEnum from 'shared/Enums/NivelUsuarioEnum';
import { nivelUsuarioEnum } from '../../../shared/Enums';
import { getDesabilitarMenuSession } from '../../../shared/services/User';
import LoaderMain from '../../Onboarding/shared/LoaderMain';
import useUsuarioLogadoHook from './useUsuarioLogadoHook';

const UsuarioLogado = ({ setMostraFundoEscuro, fixed }) => {
  const {
    setMostrarListaClientes,
    corSecundariaCliente,
    mostrarListaClientes,
    clickBuscarClientes,
    abrirListaClientes,
    nomeUsuarioLogado,
    filteredClientes,
    dadosUserLogado,
    onlySmallScreen,
    corBaseCliente,
    trocarEmpresa,
    searchHandler,
    handleKeyDown,
    valuePesquisa,
    clienteAtual,
    novoCliente,
    autenticado,
    abrirTela,
    isPending,
    location,
    clientes
  } = useUsuarioLogadoHook({ setMostraFundoEscuro });

  return (
    <>
      {novoCliente && (
        <Redirect
          to={{
            pathname: '/authentication/change-client',
            state: { cliente: novoCliente, location }
          }}
        />
      )}

      {autenticado && (
        <Box
          className={`box-usuario-logado flex-box ${fixed ? 'fixed-usuario-logado' : ''}`}
          onBlur={e => {
            if (!e.currentTarget.contains(e.relatedTarget)) {
              setMostrarListaClientes(false);
              setMostraFundoEscuro(false);
            }
          }}
        >
          {/* <IconButton className="gtm-botao-notificacoes" size="small">
            <NotificationsNone />
          </IconButton> */}
          <div
            onClick={abrirListaClientes}
            onKeyDown={abrirListaClientes}
            role="button"
            tabIndex="0"
            className={onlySmallScreen ? 'box-usuario responsive' : 'box-usuario'}
          >
            <div
              className="imagem-usuario-logado"
              style={{ backgroundColor: corBaseCliente, color: corSecundariaCliente }}
            >
              {nomeUsuarioLogado.substr(0, 1).toUpperCase()}
            </div>
            <div
              className={onlySmallScreen ? 'box-responive box-usuario-empresa' : 'box-usuario-empresa'}
            >
              <div className={clienteAtual && clienteAtual.razaoSocial ? 'nome-usuario-logado' : ''}>
                {nomeUsuarioLogado.substr(0, 18).toUpperCase()}
              </div>
              <div className="nome-empresa-selecionada white-space-nowrap">
                {onlySmallScreen && clienteAtual && clienteAtual.razaoSocial
                  ? (clienteAtual.razaoSocial.substr(0, 13) + '...').toUpperCase()
                  : clienteAtual && clienteAtual.razaoSocial
                  ? clienteAtual.razaoSocial.length > 20
                    ? (clienteAtual.razaoSocial.substr(0, 18) + '...').toUpperCase()
                    : clienteAtual.razaoSocial.toUpperCase()
                  : ''}
              </div>
            </div>
            <div className="icone-arrow-down" style={{ color: corBaseCliente }}>
              {mostrarListaClientes ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </div>
          </div>

          {mostrarListaClientes && (
            <div className={onlySmallScreen ? 'box-clientes responsive' : 'box-clientes'}>
              {clientes && clientes.length > 0 && (
                <>
                  <div className="flex-box items-centro-verticalmente">
                    <OutlinedInput
                      id="outlined-adornment-password"
                      type="text"
                      className="input-pesquisa-cliente"
                      onChange={e => searchHandler(e.target.value)}
                      onKeyDown={handleKeyDown}
                      placeholder="Pesquisar por Nome ou CNPJ"
                      autoComplete="off"
                      error={valuePesquisa.length > 0 && valuePesquisa.length <= 3 ? true : false}
                      autoFocus
                      value={valuePesquisa}
                    />
                    <Button
                      className="btn-filter-clientes"
                      onClick={() => clickBuscarClientes()}
                      disabled={valuePesquisa.length <= 3}
                    >
                      <Search />
                    </Button>
                  </div>

                  <Box className="lista-clientes">
                    {isPending && <LoaderMain tipoLoader="float" tipoImagem="circulo" />}
                    {filteredClientes.map(cliente => (
                      <div key={cliente.id}>
                        {cliente.id !== (clienteAtual && clienteAtual.id ? clienteAtual.id : 0) && (
                          <Button
                            key={cliente.id}
                            type="button"
                            title={`CNPJ: ` + cliente.cnpj}
                            onClick={() => trocarEmpresa(cliente)}
                          >
                            {cliente.razaoSocial.length > 23
                              ? (cliente.razaoSocial.substr(0, 21) + '...').toUpperCase()
                              : cliente.razaoSocial.toUpperCase()}
                          </Button>
                        )}
                      </div>
                    ))}
                  </Box>
                </>
              )}
              {dadosUserLogado && ![NivelUsuarioEnum.PROSPECT].includes(dadosUserLogado.nivel) && (
                <div className="link-todas-empresas">
                  {clientes &&
                    Object(clientes).length > 1 &&
                    (clienteAtual && clienteAtual.id ? clienteAtual.id : 0) !== 'todos' && (
                      <Button
                        type="button"
                        title="Selecionar todas as empresas"
                        onClick={() =>
                          trocarEmpresa({
                            clienteEspecial: false,
                            clienteOperaConnect: false,
                            cnpj: 'todos',
                            codCliente: 'todos',
                            dadosBrokerCliente: null,
                            id: 'todos',
                            nomeFantasia: 'TODAS AS EMPRESAS',
                            operaTrustee: 'N',
                            razaoSocial: 'TODAS AS EMPRESAS'
                          })
                        }
                      >
                        Acessar todas as empresas
                      </Button>
                    )}
                </div>
              )}

              {![nivelUsuarioEnum.CLIENTE, nivelUsuarioEnum.PROSPECT].includes(
                dadosUserLogado.nivel
              ) && (
                <div className="link-cadastrar-empresa">
                  <Button
                    type="button"
                    className="link-cadastrar-empresa"
                    title="Selecionar todas as empresas"
                    onClick={() => abrirTela('entrada-cnpj-onboarding')}
                    sx={{ width: '100%', textTransform: 'none' }}
                  >
                    <Add />
                    Cadastrar outra empresa
                  </Button>
                </div>
              )}

              {!getDesabilitarMenuSession() && (
                <div>
                  <Button
                    type="button"
                    className="texto-cor-preto link-logout"
                    title="Sair do sistema"
                    onClick={() => abrirTela('authentication/logout')}
                  >
                    Encerrar sessão
                  </Button>
                </div>
              )}
            </div>
          )}
        </Box>
      )}
    </>
  );
};
export default memo(UsuarioLogado);
